import { render, staticRenderFns } from "./MemberService.vue?vue&type=template&id=11b82d81&"
import script from "./MemberService.vue?vue&type=script&lang=js&"
export * from "./MemberService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports